import { type ClassValue, clsx } from "clsx";

// Class-name composer. daisyUI components are plain classes, so clsx is
// enough (no tailwind-merge). Other small cross-cutting helpers
// (sleep, formatters, …) get added here so the app has one place to look
// for utilities.
export function cn(...inputs: ClassValue[]) {
	return clsx(inputs);
}

// Awaitable delay. Used by mock api implementations to add realistic
// latency so loading-state UX stays honest during dev.
export const sleep = (ms: number): Promise<void> =>
	new Promise((resolve) => setTimeout(resolve, ms));
